import { mockContact } from '@/mocks/home';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm text-foreground-600 max-w-[500px] mx-auto">
            有好看的漫画想推荐？有优质作品想投稿？欢迎随时联系我们
          </p>
        </div>

        <div className="max-w-[700px] mx-auto">
          <div className="bg-background-50 border border-background-200/70 rounded-lg p-6 md:p-10">
            <p className="text-sm text-foreground-600 leading-relaxed mb-8 text-center">
              {mockContact.description}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
              <div className="flex flex-col items-center p-4 bg-background-100 rounded-lg">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 mb-3">
                  <i className="ri-mail-line text-xl"></i>
                </div>
                <span className="text-xs text-foreground-500 mb-1">电子邮箱</span>
                <span className="text-sm text-foreground-800 font-medium">{mockContact.email}</span>
              </div>

              <div className="flex flex-col items-center p-4 bg-background-100 rounded-lg">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-50 text-accent-500 mb-3">
                  <i className="ri-qq-line text-xl"></i>
                </div>
                <span className="text-xs text-foreground-500 mb-1">QQ群</span>
                <span className="text-sm text-foreground-800 font-medium">{mockContact.qq}</span>
              </div>

              <div className="flex flex-col items-center p-4 bg-background-100 rounded-lg">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-50 text-secondary-500 mb-3">
                  <i className="ri-wechat-line text-xl"></i>
                </div>
                <span className="text-xs text-foreground-500 mb-1">微信公众号</span>
                <span className="text-sm text-foreground-800 font-medium">{mockContact.wechat}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}